import {http_client} from "@/plugins/http_client";

const url = '/api/v1/rutas'
// const getAuthorizedPaths=async()=>await http_client(`${url}/get-rutas`)
const getAuthorizedPaths=async(query = {})=>await http_client(`/api/v1/utils/show-menu/cliente`, query, 'get')

export default {
    getAuthorizedPaths
}